export const GENERATED_RECORD_HOLD_EVENT = 'generated-record:hold';
export const GENERATED_RECORD_UNHOLD_EVENT = 'generated-record:unhold';
export const GENERATED_RECORD_LOCK_CHANGED_EVENT = 'generated-record:lock-changed';
export const GENERATED_RECORD_LOCK_LOST_EVENT = 'generated-record:lock-lost';

export interface GeneratedRecordLockEvent {
  generatedRecordId: number;
  // Present on lock-lost only, which goes to the holder alone.
  inUseToken?: string;
}

export function isGeneratedRecordLockEvent(value: unknown): value is GeneratedRecordLockEvent {
  if (typeof value !== 'object' || value === null) return false;
  const { generatedRecordId, inUseToken } = value as Record<string, unknown>;
  return (
    typeof generatedRecordId === 'number' &&
    (inUseToken === undefined || typeof inUseToken === 'string')
  );
}

export function isHoldAccepted(reply: unknown): boolean {
  return (
    typeof reply === 'object' && reply !== null && (reply as Record<string, unknown>).ok === true
  );
}
